import type { Comic } from "@/types/comic";

export type SortKey = "update" | "popular" | "alpha";
export type StatusKey = "all" | "连载" | "完结";

export const SORT_OPTIONS: { key: SortKey; label: string }[] = [
  { key: "update", label: "更新时间" },
  { key: "popular", label: "人气" },
  { key: "alpha", label: "字母" },
];

export const STATUS_OPTIONS: { key: StatusKey; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "连载", label: "连载中" },
  { key: "完结", label: "已完结" },
];

export interface FilterState {
  genres: string[];
  status: StatusKey;
  sort: SortKey;
  keyword: string;
}

export function filterComics(list: Comic[], state: FilterState): Comic[] {
  const kw = state.keyword.trim().toLowerCase();
  let result = list.filter((comic) => {
    const matchGenre =
      state.genres.length === 0 || state.genres.some((g) => comic.genres.includes(g));
    const matchStatus = state.status === "all" || comic.status === state.status;
    const matchKeyword =
      !kw ||
      comic.title.toLowerCase().includes(kw) ||
      comic.author.toLowerCase().includes(kw);
    return matchGenre && matchStatus && matchKeyword;
  });

  result = [...result].sort((a, b) => {
    if (state.sort === "popular") return b.favorites - a.favorites;
    if (state.sort === "alpha") return a.title.localeCompare(b.title, "zh-Hans-CN");
    return a.updateTime < b.updateTime ? 1 : -1;
  });

  return result;
}

export const PAGE_SIZE = 8;

export function paginate<T>(list: T[], page: number, size = PAGE_SIZE): T[] {
  const start = (page - 1) * size;
  return list.slice(start, start + size);
}